import { BASE_APP_HOST_URL } from "rivals/services/base";
import {
  List,
  ListKinds,
  ListTypes
} from "rivals/shared/interfaces/adminLists";

const getRanksListPath = ({
  kind,
  year,
  sport,
  listId,
  positionAbbreviation,
  stateName
}: List): string => {
  let path = "";
  if (
    [
      ListKinds.RIVALS_100,
      ListKinds.RIVALS_150,
      ListKinds.RIVLAS_250,
      ListKinds.JUCO,
      ListKinds.PREP
    ].includes(kind)
  ) {
    path = `prospect_rankings/${kind}/${year}`;
  } else if (kind === ListKinds.POSITION) {
    path = `position_rankings/${sport}/${year}/${positionAbbreviation}`;
  } else if (kind === ListKinds.STATE) {
    path = `state_rankings/${year}/${stateName
      ?.toLowerCase()
      ?.replace(/\s/g, "_")}`;
  } else {
    path = `ranks/${listId}`;
  }
  return `${BASE_APP_HOST_URL}/${path}`;
};

export const getListPath = (list: List): string => {
  if (list.listType === ListTypes.ROSTER) {
    return `/rosters/${list.listId}`;
  } else if (list.listType === ListTypes.DEPTH_CHART) {
    return `/depth_charts/${list.listId}`;
  } else if (list.listType === ListTypes.RANK) {
    return getRanksListPath(list);
  }
  return "";
};
